import { setOnSuccessSubmit } from '@/reducers/events';
import { getErrors, loading, tickets } from '@/reducers/tickets';
import { headers } from '@/services/headers';
import { ThunkAction } from '@reduxjs/toolkit';
import axios from 'axios';
import toast from 'react-hot-toast';
import { RootState } from '../store';

interface CustomModalFormInterface {
  id: number;
  customer_field_id: number;
  label: string;
  name: string;
  type: string;
  content: string | null;
  possible_values: string[];
  media: File | undefined;
  checked: boolean;
  mandatory: boolean;
}

export const UpdateTicketInformation =
  (
    eventId: string,
    attributes: {
      studios?: any;
      tickets?: any;
      channels: any;
      is_need_supported_images: boolean;
      supported_images: any;
      customer_data: CustomModalFormInterface[];
      assigned_type: string;
    }
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/tickets',
        attributes,
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(setOnSuccessSubmit('ticket-updated'));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const GetTickets =
  (slug?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL + '/org/events/' + slug + '/tickets',
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(tickets(response.data.data));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const UpdateTicketStatus =
  (id: number, status: boolean): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .patch(
        process.env.REACT_APP_BASE_URL + '/org/events/tickets/' + id,
        {
          status: status ? 'active' : 'inactive',
        },
        {
          headers: headers(),
        }
      )
      .then(() => {
        toast.success('Status tiket berhasil diubah');
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        toast.error(`Status tiket gagal diubah: ${message}`);

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };
